"use client";

import { BrandSplashMark } from "@/components/icons/SiteMarks";

export function SiteOverlays() {
  return (
    <>
      <div className="dummy_line" style={{ visibility: "hidden" }} aria-hidden="true" />
      <div className="dummy_line" style={{ visibility: "hidden" }} aria-hidden="true" />
      <div
        className="menu_overlay overlay_set full_page"
        style={{ visibility: "hidden" }}
        aria-hidden="true"
      />
      <div
        className="site_overlay overlay_set full_page f a-c j-c"
        style={{ visibility: "hidden" }}
        aria-hidden="true"
      >
        <BrandSplashMark />
      </div>
    </>
  );
}
